export default ["Police", "MNDF"];
